import { createSetting } from '@/utils/createSetting';

/**
 * setting用于保存全局常量配置信息
 */
const setting: any = {
  repo: {
    defaultBranch: 'main',
    defaultFile: 'README.md'
  },
  role: {
    visitor: 10,
    custom: 15, // 自定义
    developer: 30,
    maintainer: 40, // 维护者
    admin: 50
  }
};

export {
  setting,
  createSetting
};
